import moment from 'moment'

export const JSON_FIELDS_CSV = {
    scanDataHistory: {
        pt: {
            json_fields: {
                'Data planejada': 'plannedDate',
                'Hora da leitura': 'readingTime',
                Empresa: 'account',
                Cliente: 'client',
                Local: 'site',
                Ponto: 'point',
                Status: 'status',
            },
            json_data: [
                {
                    plannedDate: '',
                    readingTime: '',
                    account: '',
                    client: '',
                    site: '',
                    point: '',
                    status: '',
                },
            ],
            json_meta: [
                [
                    {
                        key: 'charset',
                        value: 'utf-8',
                    },
                ],
            ],
            pdfTitle: 'RELATÓRIO DE DADOS HISTÓRICOS',
            title: 'RELATÓRIO DE DADOS HISTÓRICOS - ' + 'Relatório gerado em: ' + moment().format('DD/MM/YYYY') + ' às ' + moment().format('HH:mm:ss'),
            filename: 'scan_data_history_' + moment().format('YYYY-MM-DD'),
        },
        en: {
            json_fields: {
                'Planned Date': 'plannedDate',
                'Reading Time': 'readingTime',
                Company: 'account',
                Client: 'client',
                Site: 'site',
                Checkpoint: 'point',
                Status: 'status',
            },
            json_data: [
                {
                    plannedDate: '',
                    readingTime: '',
                    account: '',
                    client: '',
                    site: '',
                    point: '',
                    status: '',
                },
            ],
            json_meta: [
                [
                    {
                        key: 'charset',
                        value: 'utf-8',
                    },
                ],
            ],
            pdfTitle: 'DATA HISTORY REPORT',
            title: 'DATA HISTORY REPORT - ' + 'Report generated on: ' + moment().format('MM/DD/YYYY') + ' at ' + moment().format('HH:mm:ss'),
            filename: 'scan_data_history_' + moment().format('YYYY-MM-DD'),
        },
    },
}
